import { render } from "./EventList.vue?vue&type=template&id=345f11d7&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=345f11d7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-345f11d7"

export default script